export default __webpack_public_path__ + "static/media/LOGIN.493e144f.svg";